import { TableInventory } from './components'

export const TabInventory = () => {
  return <TableInventory />
}
